import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

const SelectExpTime = (props) => {
  const { loginExpTime, setLoginExpTime, fullWidth = false } = props;

  const [expTime, setExpTime] = useState(null);

  const timeToSec = (dateTime) => {
    const time = new ZDate(dateTime);
    const hour = time.getHours();
    const min = time.getMinutes();
    const sec = time.getSeconds();

    return (hour * 60 * 60) + (min * 60) + sec;
  }

  const calcExpTime = (expireTime) => {
    if (typeof expireTime === "number") {
      const date = new ZDate("1970", "01", "01", "00", "00", "00");
      return date.setSeconds(expireTime);
    }
    return timeToSec(expireTime);
  }

  useEffect(() => {
    if (loginExpTime) {
      setExpTime(calcExpTime(loginExpTime));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginExpTime]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        ampm={false}
        openTo="hours"
        views={['hours', 'minutes']}
        format="HH:mm"
        mask="__:__"
        label={t("loginExpTime")}
        value={expTime}
        onChange={(newValue) => {
          setExpTime(newValue);
          setLoginExpTime(calcExpTime(newValue));
        }}
        slotProps={{ textField: { fullWidth, sx: { '& .MuiButtonBase-root': { mr: "0 !important" } } } }}
      />
    </LocalizationProvider>
  )
};

export default SelectExpTime;